export default [

     {
          path: '/task',
          name: 'Task',
          component: () => import("@/views/Page/StrategicPlan/Task/Task.vue"),
           meta: {
               title: 'Task',
          },
     }
];